import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from 'app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { LanguageMenuComponent } from './language-menu.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [LanguageMenuComponent],
  imports: [
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    SharedModule,
    RouterModule,
    MatTooltipModule,
  ],
  exports: [LanguageMenuComponent],
})
export class LanguageMenuModule {}
